import { useState, FC } from "react";

import { Button } from "react-bootstrap";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { toast } from "react-toastify";

import { Chips, ChipsChangeEvent } from "primereact/chips";
import { Divider } from "primereact/divider";
import { SelectButton, SelectButtonChangeEvent } from "primereact/selectbutton";

import { excludeWhitespace } from "../../../../_helpers/stringHelper";
import Input from "../../../../common/components/form/Input";

interface ILocationTeamFormProps {
  disabled?: boolean;
}

const LocationTeamForm: FC<ILocationTeamFormProps> = ({ disabled = false }) => {
  const { control, watch, setValue, getValues } = useFormContext();
  const options = ["Secteurs", "Radius"];
  const [locationType, setTypeLocation] = useState(
    getValues("radii")?.length > 0 ? options[1] : options[0]
  );
  const { fields, append, remove } = useFieldArray({
    control,
    name: "radii",
  });

  const locationHandler = (e: SelectButtonChangeEvent) => {
    if (!e.value) {
      return;
    }
    if (e.value === options[1] && watch("sectors")?.length > 0) {
      if (
        confirm(
          "Vos données secteurs vont être supprimées.\nVoulez vous continuer ?"
        ) !== true
      ) {
        return;
      }
      setValue("sectors", []);
    }
    if (e.value === options[0] && watch("radii")?.length > 0) {
      if (
        confirm(
          "Vos données radius vont être supprimées.\nVoulez vous continuer ?"
        ) !== true
      ) {
        return;
      }
      setValue("radii", []);
    }
    e.value && setTypeLocation(e.value);
  };

  const findDuplicates = (arr: string[]) =>
    arr.filter((item, index) => arr.indexOf(item) !== index);

  const handleChipsSectors = (e: ChipsChangeEvent) => {
    let processedValues: string[] = [];

    if (e.value && e.value.length > 0) {
      e.value.forEach((item: string) => {
        if (item.includes(",")) {
          const splitItems = item
            .split(",")
            .map((part) => excludeWhitespace(part.trim()))
            .filter((part) => part !== "");
          processedValues = [...processedValues, ...splitItems];
        } else {
          processedValues.push(excludeWhitespace(item));
        }
      });

      if (findDuplicates(processedValues).length > 0) {
        toast.warning(
          "Attention duplicata détecté : " +
            findDuplicates(processedValues).join(",")
        );
      }

      setValue("sectors", [...new Set(processedValues)]);
    } else {
      setValue("sectors", []);
    }
  };

  return (
    <div className="d-flex gap-5">
      <SelectButton
        value={locationType}
        onChange={(e) => locationHandler(e)}
        options={options}
        disabled={disabled}
      />
      {locationType === options[0] ? (
        <Controller
          control={control}
          name={"sectors"}
          render={({ field }) => (
            <Chips
              value={field.value}
              onChange={handleChipsSectors}
              disabled={disabled}
              separator=","
            />
          )}
        />
      ) : (
        <div className="d-flex flex-column gap-3">
          <Button
            variant="outline-primary"
            onClick={() => {
              append({});
            }}
            disabled={disabled}
          >
            <i className="bi bi-plus-lg" />
            Ajouter un radius
          </Button>
          {fields.map((field, index) => (
            <div className="d-flex flex-column gap-3" key={index}>
              <Input
                control={control}
                label="latitude"
                name={`radii.${index}.latitudeY` as any}
                defaultValue=""
                rules={{ required: "Veuillez une latitude" }}
                disabled={disabled}
              />
              <Input
                control={control}
                label="longitude"
                name={`radii.${index}.longitudeX` as any}
                defaultValue=""
                rules={{ required: "Veuillez une longitude" }}
                disabled={disabled}
              />
              <Input
                control={control}
                label="Radius"
                name={`radii.${index}.radius` as any}
                defaultValue=""
                rules={{ required: "Veuillez une longitude" }}
                disabled={disabled}
              />
              {!disabled && (
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => remove(index)}
                >
                  Supprimer
                </Button>
              )}
              <Divider />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationTeamForm;
